

















import BlueButton from '@/views/atoms/BlueButton.vue'
import TextDatePicker from '@/views/molecules/TextDatePicker.vue'
import Global from '@/common/global.js'
import TextBox from '@/views/atoms/TextBox.vue'
import store from '@/store'

export default
  name: 'ContainerTable'
  components: {
    BlueButton
    TextDatePicker
    TextBox
  }

  data: () ->
    capacityList: Global.capacity()
    text: ''

  props:
    containerList:
      type: Array
      default: []

  methods: {
    click: (id) ->
      param =
        id: id
        remarks: @text
      @$emit('click', param)
    clickDelete: (id) ->
      param =
        id: id
      @$emit('clickDelete', param)
    returnCapacity: (capacity) ->
      for row, index in @capacityList
        if capacity == row.id
          return row.name
      return ''
    change: (v) ->
      @text = v.val
  }
